import React from 'react';

const s = {
  wrap: {
    display: 'flex', flexDirection: 'column', gap: 12, padding: 16,
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(10,10,10,0.95)',
  },
  row: { display: 'flex', alignItems: 'center', gap: 12 },
  label: { fontSize: 12, color: '#94A3B8', width: 90, flexShrink: 0 },
  value: { fontSize: 12, color: '#94A3B8', width: 32, textAlign: 'right' },
  range: { flex: 1, accentColor: '#7C3AED' },
  input: {
    flex: 1, background: '#111', color: '#F8FAFC', fontSize: 12,
    borderRadius: 6, padding: '6px 10px', border: '1px solid rgba(255,255,255,0.1)',
    outline: 'none',
  },
  textarea: {
    background: '#111', color: '#F8FAFC', fontSize: 12, borderRadius: 6,
    padding: '8px 10px', border: '1px solid rgba(255,255,255,0.1)',
    resize: 'none', outline: 'none', fontFamily: 'inherit',
  },
};

export default function ParameterControls({ params, onChange }) {
  const update = (key, value) => onChange({ ...params, [key]: value });

  return (
    <div style={s.wrap}>
      <div style={s.row}>
        <label style={s.label}>Temperature</label>
        <input
          type="range" min="0" max="2" step="0.1"
          value={params.temperature}
          onChange={e => update('temperature', parseFloat(e.target.value))}
          style={s.range}
        />
        <span style={s.value}>{params.temperature}</span>
      </div>
      <div style={s.row}>
        <label style={s.label}>Max tokens</label>
        <input
          type="number" min="1" max="128000"
          value={params.maxTokens}
          onChange={e => update('maxTokens', parseInt(e.target.value) || 4096)}
          style={s.input}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <label style={s.label}>System prompt</label>
        <textarea
          value={params.systemPrompt}
          onChange={e => update('systemPrompt', e.target.value)}
          placeholder="You are a helpful assistant..."
          rows={3}
          style={s.textarea}
        />
      </div>
    </div>
  );
}
